import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"text":"","color":"error"},on:{"click":_vm.exit}},[_vm._v(" Cancel ")]),_c(VBtn,{attrs:{"color":"success","text":"","disabled":_vm.notAdmin && !_vm.disabledSubmit},on:{"click":_vm.submit}},[_vm._v(" Save changes ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }